
























































































import { Component, Prop, Vue } from "vue-property-decorator";
import Dancers from "./Dancers.vue";

@Component({
  components: {
    Dancers
  }
})
export default class DancerByNight extends Vue {
  @Prop() isDay!: boolean;
}
